export const maximumPriceForPaymentOnDelivery = 5000;
